module.exports = __webpack_public_path__ + "media/800-3_SERF_2022_EmailRedFlags.e31d0da9.mp4";